/* eslint-disable import/no-anonymous-default-export */
import axios from "axios";
import { kore_url } from "./index";
import { ThresholdInterface } from "../../context/initialState/Threshold";
import saveAs from "file-saver";

export default {
  getAll: async (token: string, type?: string, count?: boolean, select?: string, view?: string) => {
    const config = { headers: { Authorization: `Bearer ${token}` } };
    const params = new URLSearchParams();
    // TODO: remove fix for issue with coordinator permissions
    if (type) params.append("type", type);
    if (select) params.append("select", select);
    if (view) params.append("view", view);
    const query = params.toString() ? `?${params.toString()}` : "";
    const countFilter = count ? "/count" : "";
    return await axios
      .get(`${kore_url}/api/v2/readings${countFilter}${query}`, config)
      .then((readingList) => {
        return readingList.data;
      })
      .catch((err) => console.log(err));
  },
  getLatest: async (token: string) => {
    const config = {
      headers: { Authorization: `Bearer ${token}` }
    };
    return await axios
      .get(kore_url + "/api/v2/readings", config)
      .then((readingList) => {
        return readingList.data;
      })
      .catch((err) => console.log(err));
  },
  getForOne: async (
    memberID: string,
    token?: string,
    readingType?: string,
    param?: string
  ) => {
    const config = {
      headers: { Authorization: `Bearer ${token}` }
    };
    // TODO: remove fix for issue with coordinator permissions
    return await axios
      .get(
        `${kore_url}/api/v2/readings?filter=memberId:${memberID}${
          readingType ? "&type=" + readingType : ""
        }${param ? `&${param}` : ""}`,
        config
      )
      .then((readingList) => {
        return readingList.data;
      })
      .catch((err) => console.log(err));
  },
  getForOnePDF: async (
    memberID: string,
    fileName: string,
    token?: string,
    readingType?: string,
    param?: string
  ) => {
    const config = {
      method: "GET",
      url: `${kore_url}/api/v2/readings?format=pdf&filter=memberId:${memberID}${
        readingType ? "&type=" + readingType : ""
      }${param ? `&${param}` : ""}`,
      headers: {
        "Access-Control-Allow-Origin": "*",
        Authorization: `Bearer ${token}`
      }
    };

    axios({
      url: config.url,
      headers: config.headers,
      method: "GET",
      responseType: "blob" // Important: This tells axios to expect binary data
    })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        saveAs(blob, `${fileName}.pdf`);
      })
      .catch((error) => {
        // Handle error if necessary
        console.error("Error while downloading PDF:", error);
      });
  },

  getCountForOne: async (
    memberID: string,
    token?: string,
    readingType?: string,
    param?: string
  ) => {
    const config = {
      headers: { Authorization: `Bearer ${token}` }
    };
    return await axios
      .get(
        `${kore_url}/api/v2/readings?filter=memberId:${memberID}${
          readingType ? "&type=" + readingType : ""
        }${param ? param : ""}`,
        config
      )
      .then((readingList) => {
        return readingList.data;
      })
      .catch((err) => console.log(err));
  },
  getCount: async (
    memberID: string,
    token: string,
    readingType?: string,
    param?: string
  ) => {
    const config = {
      headers: { Authorization: `Bearer ${token}` }
    };
    return await axios
      .get(
        `${kore_url}/api/v2/readings/count?filter=memberId:${memberID}${
          readingType ? "&type=" + readingType : ""
        }${param ? param : ""}`,
        config
      )
      .then((readingList) => {
        return readingList.data;
      })
      .catch((err) => console.log(err));
  },
  getRecentReadings: async (memberID: string, token: string) => {
    const config = {
      headers: { Authorization: `Bearer ${token}` }
    };

    return await axios
      .get(`${kore_url}/api/v2/members/recents/${memberID}`, config)
      .then((readingList) => {
        return readingList.data;
      })
      .catch((err) => {
        // Return an empty object (not undefined) so callers that destructure
        // the result -- e.g. formatRows -- don't throw on a single member's
        // failed readings fetch and wipe the entire grid load.
        console.log(err);
        return {};
      });
  },
  getSingleReading: async (readingID: string, token: string) => {
    const config = {
      headers: { Authorization: `Bearer ${token}` }
    };
    return await axios
      .get(`${kore_url}/api/v2/readings/${readingID}`, config)
      .then((readingList) => {
        return readingList.data;
      })
      .catch((err) => console.log(err));
  },
  getThreshold: async (
    memberID: string,
    thresholdType: string | undefined,
    token: string,
    param?: string
  ) => {
    const config = {
      headers: { Authorization: `Bearer ${token}` }
    };

    let url = `${kore_url}/api/v4/thresholds/${memberID}`;
    const queryParams: string[] = [];
    if (thresholdType) queryParams.push(`type=${thresholdType}`);
    if (param) queryParams.push(param);
    if (queryParams.length) url += `?${queryParams.join("&")}`;

    return await axios
      .get(url, config)
      .then((res) => res.data)
      .catch((err) => {
        throw err;
      });
  },
  setThreshold: async (threshold: ThresholdInterface, token: string) => {
    const config = {
      headers: { Authorization: `Bearer ${token}` },
      data: threshold,
      url: `${kore_url}/api/v4/thresholds`,
      method: "POST"
    };
    return await axios(config)
      .then((newThreshold) => {
        return newThreshold.data;
      })
      .catch((err) => {
        throw err;
      });
  },
  removeThreshold: async (entityId: string, token: string) => {
    const config = {
      headers: { Authorization: `Bearer ${token}` }
    };
    return await axios
      .delete(`${kore_url}/api/v4/thresholds/${entityId}`, config)
      .then((newThreshold) => {
        return newThreshold.data;
      })
      .catch((err) => {
        throw err;
      });
  },
  updateThreshold: async (
    entityId: string,
    threshold: ThresholdInterface,
    token: string
  ) => {
    const config = {
      headers: { Authorization: `Bearer ${token}` },
      data: { value: threshold },
      url: `${kore_url}/api/v4/thresholds/${entityId}`,
      method: "PUT"
    };
    return await axios(config)
      .then((newThreshold) => {
        return newThreshold.data;
      })
      .catch((err) => {
        throw err;
      });
  },
  getInvalidateReasons: async (token: string) => {
    const config = {
      method: "get",
      url: `${kore_url}/api/v4/readings/reasons`,
      headers: { Authorization: `Bearer ${token}` }
    };
    return await axios(config)
      .then((res) => res.data)
      .catch((err) => { throw err; });
  },

  invalidate: async (readingId: string, body: any, token: string) => {
    const config = {
      method: "post",
      url: `${kore_url}/api/v4/readings/${readingId}/invalidate`,
      headers: { Authorization: `Bearer ${token}` },
      data: body
    };
    return await axios(config)
      .then((res) => res.data)
      .catch((err) => { throw err; });
  }
};
